import type { State } from '../../typings'

export const deleteActivityTypeProducer = (state: State, payload?: string) => {
  const activityTypes = payload
    ? state.activityTypes.filter((activity) => activity.id !== payload)
    : state.activityTypes

  return {
    ...state,
    deleteDialogOpened: false,
    underDeletion: undefined,
    activityTypes,
  }
}
